import React from 'react';
import { useSelector } from 'react-redux';
import { useEmbedParams } from 'src/hooks/useEmbedParams';
import { RootState } from 'src/store/store';
import { XptSecondaryNavBar } from './XptSecondaryNavBar';
import { XptTopNavigation } from './XptTopNavigation';

// when currentUserNotFound show only XptTopNavigation
// when !currentUserNotFound show both XptTopNavigation & XptSecondaryNavBar
// Now, after adding this feature "isEmbedded"
// when isEmbedded is true dont show "XptTopNavigation", show only XptSecondaryNavBar
export const XPTGlobalTopNavigation: React.FC = () => {
  const { currentUserNotFound } = useSelector((state: RootState) => state.xptAccessAndAuthorizationStore);
  const { isEmbedded } = useEmbedParams();

  // When embedded: Always show only XptSecondaryNavBar (regardless of currentUserNotFound)
  if (isEmbedded) {
    return (
      <div id="h2">
        <XptSecondaryNavBar />
      </div>
    );
  }

  // When not embedded and currentUserNotFound: Show only XptTopNavigation
  if (currentUserNotFound) {
    return (
      <div id="h2">
        <XptTopNavigation />
      </div>
    );
  }

  // When not embedded and user found: Show both XptTopNavigation & XptSecondaryNavBar
  return (
    <div id="h">
      <XptTopNavigation />
      <XptSecondaryNavBar />
    </div>
  );
};
